const wrapSetStateEvent = (setState, callback) => (event) => {
  const { value } = event.target;
  setState(value);
  if (typeof callback === 'function') {
    callback(value);
  }
};

export default wrapSetStateEvent;
